var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CFileDownload',{attrs:{"fileName":`${_vm.$t('ctx.discount.detail.associated-structures-file')}.csv`,"fileContent":_vm.fileContent,"placeholder":_vm.placeholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }